// extracted by mini-css-extract-plugin
export var divider = "_w5-0";